<template>
  <div>
    <h3 class="title">検索条件</h3>
    <ValidationObserver ref="observer" tag="form">
      <table class="table">
        <tbody>
          <tr>
            <td>棚卸識別名</td>
            <td>
              <ValidationProvider v-slot="{ errors }" rules="max:50">
                <input type="text" class="form-control enterp-codeInput" :name="itemName.inventoryName"
                  v-model="inventoryName" autocomplete="off"/>
                <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <td>アップロード日</td>
            <td>
              <ValidationProvider class="inline" v-slot="{ errors }" :name="itemName.uploadDateFrom" rules="regex:^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$">
                <Datepicker class="inline" v-model="uploadDateFrom" input-class="form-control dateInput"
                  :calendar-button="true" :calendar-button-icon="'fa fa-calendar-alt calendarIcon'" :clear-button="true"
                  :format="formatDateFrom" :language="ja" placeholder="例：2019-01-10"></Datepicker>
                <span class="errMsg errInline inline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
              <span class="inline tilde">～</span>
              <ValidationProvider class="inline" v-slot="{ errors }" :name="itemName.uploadDateTo" rules="regex:^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$">
                <Datepicker class="inline" v-model="uploadDateTo" input-class="form-control dateInput"
                  :calendar-button="true" :calendar-button-icon="'fa fa-calendar-alt calendarIcon'" :clear-button="true"
                  :format="formatDateTo" :language="ja" placeholder="例：2019-01-10"></Datepicker>
                <span class="errMsg errInline inline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
              </ValidationProvider>
            </td>
          </tr>
          <tr>
            <td>アップロードユーザ</td>
            <td>
              <input type="text" class="form-control enterp-codeInput" :name="itemName.uploadUserName"
                v-model="uploadUserName" autocomplete="off" />
            </td>
          </tr>
          <tr>
            <td>アップロード状態</td>
            <td>
              <select id="uploadStatus" :name="itemName.uploadStatus" class="form-control enterp-codeInput" v-model="uploadStatus">
                <option value="">選択して下さい</option>
                <option :value="0">取込待ち</option>
                <option :value="1">取込完了</option>
                <option :value="2">取込失敗</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </ValidationObserver>
    <RfidButton :display="'inline'" @handleClick="search">検索</RfidButton>
    <router-link :to="{ name: 'stock-file-upload' }" class="btn btn-primary btn-lg w200" tag="button" v-if="isUploadButtonShown">
      新規アップロード
    </router-link>
    <br><br>
  </div>
</template>

<script>
import RfidButton from '@/components/atoms/RfidButton'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'inventory-target-file-search-window',

  components: {
    ValidationObserver,
    ValidationProvider,
    RfidButton,
    Datepicker
  },

  data () {
    return {
      inventoryName: '',
      uploadDateFrom: '',
      uploadDateTo: '',
      uploadUserName: '',
      uploadStatus: '',
      itemName: {},
      ja: ja,
      isUploadButtonShown: false,
      entity: {
        enterpriseCode: null,
        enterpriseName: null,
        enterpriseAuthCode: null,
        enterpriseAuthPass: null,
        domain: null,
        licenseStartDate: null,
        licenseEndDate: null,
        licenseType: 0,
        businessType: 0,
        manualInventoryPermitDiv: 0,
        simpleAuthenticationDiv: 0,
        inventoryDeleteDiv: 0,
        inventoryCancelDiv: 0,
        accountbookDiv: 0
      }
    }
  },

  async created () {
    this.itemName = this.item()
    var params = {
      enterpriseCode: this.$session.get('enterpriseCode'),
      enterpriseCreateDateFrom: '',
      enterpriseCreateDateTo: ''
    }
    // 企業情報操作（取得）API
    var response = await this.axios.get('/api/enterprise/get', {
      params: params,
      headers: {
        'Authorization': this.$session.get('accessToken'),
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*'
      }
    })
    this.entity = response.data[0]
    if (this.entity.accountbookDiv === 0) {
      this.isUploadButtonShown = true
    }
  },

  methods: {
    async search () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }
      this.$emit('search', this.inventoryName, this.uploadDateFrom, this.uploadDateTo, this.uploadUserName, this.uploadStatus)
    },

    customformat (value) {
      this.uploadDateFrom = this.$moment(value).format('YYYY-MM-DD')
      return this.uploadDateFrom
    },

    formatDateFrom (value) {
      this.uploadDateFrom = this.$moment(value).format('YYYY-MM-DD')
      return this.uploadDateFrom
    },

    formatDateTo (value) {
      this.uploadDateTo = this.$moment(value).format('YYYY-MM-DD')
      return this.uploadDateTo
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/InventoryTargetFileSearchWindow.vue